import { Button, Chip, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { isEmpty, map } from 'lodash';
import { filterEvents } from 'store/thunks/eventThunks';

const getDateRange = (dateRange) => {
  const dateArray = Array.isArray(dateRange) ? dateRange : [dateRange];
  const dates = map(dateArray, (date) => {
    const [year, month, day] = date.split('-').map(Number);
    return format(new Date(year, month - 1, day), 'MM/dd/yyyy');
  });

  return dates.length === 1 ? `${dates[0]}` : `${dates[0]} - ${dates[1]}`;
};

const EventsFilterStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ criticalEvents }) => criticalEvents.events?.filter);

  const removeFilter = (filterName) => () => {
    dispatch(
      filterEvents({
        filter: {
          ...filter,
          [filterName]: undefined,
        },
      })
    );
  };

  // "Remove All" clears every filter — createdAt, eventType, pomUserName.
  const removeAllFilter = () =>
    dispatch(
      filterEvents({
        filter: {
          createdAt: undefined,
          eventType: undefined,
          pomUserName: undefined,
        },
      })
    );

  const hasAnyFilter = !!(filter.pomUserName || filter.eventType || !isEmpty(filter.createdAt));

  return (
    <Stack direction='row' spacing={1} flexWrap='wrap' rowGap={1} alignItems='center'>
      {filter.pomUserName && (
        <Chip
          label={`Event Actor = ${filter.pomUserName}`}
          variant='contained'
          onDelete={removeFilter('pomUserName')}
        />
      )}

      {filter.eventType && (
        <Chip
          label={`Event Type = ${filter.eventType.replace(/_/g, ' ')}`}
          variant='contained'
          onDelete={removeFilter('eventType')}
        />
      )}

      {!isEmpty(filter.createdAt) && (
        <Chip
          label={`Date Range = ${getDateRange(filter.createdAt)}`}
          variant='contained'
          onDelete={removeFilter('createdAt')}
        />
      )}

      {hasAnyFilter && <Button onClick={removeAllFilter}>Remove All</Button>}
    </Stack>
  );
};

export default EventsFilterStatusBar;
